import styled from "styled-components";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";

export const ToggleContainer = styled.div<{
  marginLeft?: number;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
}>`
  display: flex;
  flex-direction: column;
  margin-left: ${(p) => p.marginLeft ?? 0}px;
  margin-top: ${(p) => p.marginTop ?? 0}px;
  margin-right: ${(p) => p.marginRight ?? 0}px;
  margin-bottom: ${(p) => p.marginBottom ?? 0}px;
  font-family: ${FontFamily.MontserratRegular}
`;

export const ToggleLabel = styled.label<{ required?: boolean }>`
  font-size: ${FontSize.Small};
  font-family: ${FontFamily.MontserratRegular}
  color: ${Color.Grey};
  margin-bottom: 6px;

  &::after {
    content: ${(p) => (p.required ? '" *"' : '""')};
    color: ${Color.Black};
  }
`;

export const ToggleSwitch = styled.div<{
  disabled?: boolean;
  hasError?: boolean;
}>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  border: 1px solid
    ${(p) =>
      p.hasError
        ? Color.Destructive
        : p.disabled
        ? Color.SeaBlue300
        : Color.SeaBlue400};
  border-radius: 20px;
  background: ${(p) => (p.disabled ? Color.LightGrey03 : Color.LightGrey02)};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  min-height: 36px;
  padding: 2px;
  outline: none;
  width: 200px;
  font-family: ${FontFamily.MontserratRegular}

  &:focus-visible {
    box-shadow: 0 0 0 3px ${Color.ActionColor};
    border-color: ${Color.SeaBlue600};
  }
`;

export const ToggleOption = styled.button<{}>`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 6px 10px;
  font-size: ${FontSize.Small}px;
  line-height: 1;
  color: ${Color.DarkGrey};
  border-radius: 16px; /* matches track curvature */
  z-index: 1; /* above track but below thumb shadow */
  user-select: none;

  /* active state via data attribute for simple logic in TSX */
  &[data-active="true"] {
    color: ${Color.MidnightBlue};
    font-weight: 600;
  }

  &:disabled {
    color: ${Color.Grey};
    cursor: not-allowed;
  }
`;

export const ToggleThumb = styled.div`
  position: absolute;
  top: 2px;
  bottom: 2px;
  left: 2px;
  width: calc(50% - 2px);
  border-radius: 16px;
  background: ${Color.White};
  border: 1px solid ${Color.SeaBlue300};
  box-shadow: 0 1px 2px ${Color.SeaBlue500};
  transition: transform 0.18s ease, background 0.18s ease,
    border-color 0.18s ease;

  &[data-active="true"] {
    transform: translateX(100%);
  }

  ${ToggleSwitch}[data-active="true"] & {
    background: ${Color.ActionColor};
    border-color: ${Color.SeaBlue600};
  }

  ${ToggleSwitch}[aria-invalid="true"] & {
    border-color: ${Color.Destructive};
    box-shadow: 0 0 0 1px ${Color.LightWarning} inset;
  }

  ${ToggleSwitch}[aria-disabled="true"] & {
    background: ${Color.SeaBlue200};
    border-color: ${Color.SeaBlue300};
    box-shadow: none;
  }
`;
